import { Input } from "@brg/input";
import { GridBox, useIsMobile } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EduSecetWrapper, LegalsLabel } from "shared/modals/styles";
import { useTheme } from "styled-components";
import { AgreeBlock } from "./AgreeBlock";
import { UniversitySearchBar } from "shared/components/DropdownSearchBar/UniversitySearchBar";
import { Tag } from "@brg/api";


export const CgRaveForm: FC<{
    onFullNameChange: (ev: React.BaseSyntheticEvent) => void;
    onEmailChange: (ev: React.BaseSyntheticEvent) => void;
    onUserOccupatioChange?: (ev: React.BaseSyntheticEvent) => void;
    onCountryChange: (ev: React.BaseSyntheticEvent) => void;
    onEducationChange?: (id: string) => void;
    onSelectedEduChange?: (tag: Tag<'Local'>) => void;
    onAgreeSign: (flag: boolean, data: any) => void;
    fullName: string;
    email: string;
    occupation?: string;
    country: string;
    competitionId: string;
}> = ({ 
    fullName,
    email,
    occupation,
    competitionId,
    country,
    onEducationChange,
    onSelectedEduChange,
    onCountryChange,
    onUserOccupatioChange,
    onEmailChange,
    onFullNameChange,
    onAgreeSign
}) => {
    const isMobile = useIsMobile();
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <>
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} rows={isMobile ? '' : ''} style={{ marginBottom: isMobile ? "16px" : '24px' , placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                <LegalsLabel>{t('designer_edit.fields.fullname')}</LegalsLabel>
                <Input.Text
                    style={{
                        backgroundColor: theme.competition.input.bg,
                        color: theme.competition.input.mainText,
                    }}
                    pattern='^[А-Яа-яЁёA-Za-z\s]+$'
                    onChange={(e) => onFullNameChange(e)}
                    value={fullName}
                    title={`${t('reports.only_word')}`}
                    data-type="fullName"
                    maxLength={100}
                    required
                />
            </GridBox>
            {!!onEducationChange && !!onSelectedEduChange && (
                <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start" }}>
                  <LegalsLabel>{t('designer_edit.fields.education_center')}</LegalsLabel>
                  <EduSecetWrapper>
                      <UniversitySearchBar
                          onAddClick={onEducationChange}
                          onChooseClick={onSelectedEduChange}
                          editing
                          placeholder=''
                      />
                  </EduSecetWrapper>
              </GridBox>
            )}
            {!!onUserOccupatioChange && (
                <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} rows={isMobile ? '' : ''} style={{ marginBottom: isMobile ? "16px" : '24px' , placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                    <LegalsLabel>{t('designer_edit.fields.occupation')}</LegalsLabel>
                    <Input.Text
                        style={{
                            backgroundColor: theme.competition.input.bg,
                            color: theme.competition.input.mainText,
                        }}
                        pattern='^[А-Яа-яЁёA-Za-z\s0-9]+$'
                        onChange={(e) => onUserOccupatioChange(e)}
                        value={occupation}
                        title={`${t('reports.word_and_number')}`}
                        data-type="occupation"
                        maxLength={100}
                        required
                    />
                </GridBox>
            )}
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                <LegalsLabel>{t('designer_edit.fields.email')}</LegalsLabel>
                <Input.Text
                    type="email"
                    style={{
                        backgroundColor: theme.competition.input.bg,
                        color: theme.competition.input.mainText,
                    }}
                    onChange={(e) => onEmailChange(e)}
                    pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    value={email}
                    data-type="email"
                    required
                />
            </GridBox>
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                <LegalsLabel>{t('designer_edit.fields.country')}</LegalsLabel>
                <Input.Text
                    type="text"
                    style={{
                        backgroundColor: theme.competition.input.bg,
                        color: theme.competition.input.mainText,
                    }}
                    onChange={(e) => onCountryChange(e)}
                    value={country}
                    pattern='^[А-Яа-яЁёA-Za-z\s]+$'
                    name="country"
                    className={'date-input'}
                    title={`${t('reports.only_word')}`}
                    data-type="country"
                    required
                />
            </GridBox>

            <AgreeBlock onCheck={(flag: boolean, data: any) => onAgreeSign(flag, data)} competitionId={competitionId} extraCheckboxs={true} />
</>
    )
}import { Input } from "@brg/input";
import { GridBox, useIsMobile } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EduSecetWrapper, LegalsLabel } from "shared/modals/styles";
import { useTheme } from "styled-components";
import { AgreeBlock } from "./AgreeBlock";
import { UniversitySearchBar } from "shared/components/DropdownSearchBar/UniversitySearchBar";
import { Tag } from "@brg/api";


export const CgRaveForm: FC<{
    onFullNameChange: (ev: React.BaseSyntheticEvent) => void;
    onEmailChange: (ev: React.BaseSyntheticEvent) => void;
    onUserOccupatioChange?: (ev: React.BaseSyntheticEvent) => void;
    onCountryChange: (ev: React.BaseSyntheticEvent) => void;
    onEducationChange?: (id: string) => void;
    onSelectedEduChange?: (tag: Tag<'Local'>) => void;
    onAgreeSign: (flag: boolean, data: any) => void;
    fullName: string;
    email: string;
    occupation?: string;
    country: string;
    competitionId: string;
}> = ({ 
    fullName,
    email,
    occupation,
    competitionId,
    country,
    onEducationChange,
    onSelectedEduChange,
    onCountryChange,
    onUserOccupatioChange,
    onEmailChange,
    onFullNameChange,
    onAgreeSign
}) => {
    const isMobile = useIsMobile();
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <>
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} rows={isMobile ? '' : ''} style={{ marginBottom: isMobile ? "16px" : '24px' , placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                <LegalsLabel>{t('designer_edit.fields.fullname')}</LegalsLabel>
                <Input.Text
                    style={{
                        backgroundColor: theme.competition.input.bg,
                        color: theme.competition.input.mainText,
                    }}
                    pattern='^[А-Яа-яЁёA-Za-z\s]+$'
                    onChange={(e) => onFullNameChange(e)}
                    value={fullName}
                    title={`${t('reports.only_word')}`}
                    data-type="fullName"
                    maxLength={100}
                    required
                />
            </GridBox>
            {!!onEducationChange && !!onSelectedEduChange && (
                <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start" }}>
                  <LegalsLabel>{t('designer_edit.fields.education_center')}</LegalsLabel>
                  <EduSecetWrapper>
                      <UniversitySearchBar
                          onAddClick={onEducationChange}
                          onChooseClick={onSelectedEduChange}
                          editing
                          placeholder=''
                      />
                  </EduSecetWrapper>
              </GridBox>
            )}
            {!!onUserOccupatioChange && (
                <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} rows={isMobile ? '' : ''} style={{ marginBottom: isMobile ? "16px" : '24px' , placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                    <LegalsLabel>{t('designer_edit.fields.occupation')}</LegalsLabel>
                    <Input.Text
                        style={{
                            backgroundColor: theme.competition.input.bg,
                            color: theme.competition.input.mainText,
                        }}
                        pattern='^[А-Яа-яЁёA-Za-z\s0-9]+$'
                        onChange={(e) => onUserOccupatioChange(e)}
                        value={occupation}
                        title={`${t('reports.word_and_number')}`}
                        data-type="occupation"
                        maxLength={100}
                        required
                    />
                </GridBox>
            )}
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                <LegalsLabel>{t('designer_edit.fields.email')}</LegalsLabel>
                <Input.Text
                    type="email"
                    style={{
                        backgroundColor: theme.competition.input.bg,
                        color: theme.competition.input.mainText,
                    }}
                    onChange={(e) => onEmailChange(e)}
                    pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    value={email}
                    data-type="email"
                    required
                />
            </GridBox>
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start", gridAutoFlow: isMobile ? 'dense' : 'row' }}>
                <LegalsLabel>{t('designer_edit.fields.country')}</LegalsLabel>
                <Input.Text
                    type="text"
                    style={{
                        backgroundColor: theme.competition.input.bg,
                        color: theme.competition.input.mainText,
                    }}
                    onChange={(e) => onCountryChange(e)}
                    value={country}
                    pattern='^[А-Яа-яЁёA-Za-z\s]+$'
                    name="country"
                    className={'date-input'}
                    title={`${t('reports.only_word')}`}
                    data-type="country"
                    required
                />
            </GridBox>

            <AgreeBlock onCheck={(flag: boolean, data: any) => onAgreeSign(flag, data)} competitionId={competitionId} extraCheckboxs={true} />
</>
    )
}